import { useState } from "react";
import { createPermission } from "../../api/accessControl";

export default function AddPermissionModal({ open, onClose, onCreated }) {
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");

  if (!open) return null;

  const submit = async () => {
    await createPermission({ code, description });
    onCreated();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/60">
      <div className="w-[400px] rounded-xl bg-white p-6 text-gray-900 shadow-xl dark:bg-gray-900 dark:text-gray-100">
        <h2 className="mb-4 text-lg font-bold text-gray-900 dark:text-white">
          Add Permission
        </h2>

        <input
          className="input mb-3 border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500"
          placeholder="PERMISSION_CODE"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />

        <textarea
          className="input mb-4 border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="btn btn-secondary dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700"
          >
            Cancel
          </button>
          <button onClick={submit} className="btn btn-primary">
            Save
          </button>
        </div>
      </div>
    </div>
  );
}